<template>
  <q-input ref="input"
           :value="value"
           :type="type"
           :tabindex="tabindex"
           :autofocus="autofocus"
           :debounce="debounce"
           :bottom-slots="bottomSlots"
           :color="color"
           :bg-color="bgColor"
           :error="error"
           :error-message="errorMessage"
           :hide-bottom-space="hideBottomSpace"
           :borderless="borderless"
           :standout="standout"
           :maxlength="maxlength"
           :placeholder="placeholder"
           :autocomplete="autocomplete"
           :input-style="inputStyle"
           :input-class="inputClass"
           v-on="$listeners">
    <template #hint>
      <slot name="hint">
        <div v-if="hint">{{ hint }}</div>
      </slot>
    </template>
    <template #append>
      <slot name="append">
        <q-icon v-if="appendIcon" :name="appendIcon" />
      </slot>
    </template>
  </q-input>
</template>

<script>

export default {
  name: 'RInput',
  props: {
    debounce: {
      type: Number,
      required: false,
      default: 500,
    },
    value: [String, Number],
    hint: String,
    placeholder: String,
    tabindex: Number,
    maxlength: Number,
    type: String,
    appendIcon: String,
    autofocus: Boolean,
    error: Boolean,
    errorMessage: String,
    color: String,
    bgColor: String,
    hideBottomSpace: {
      type: Boolean,
      default: false,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    standout: {
      type: [Boolean, String],
      default: false,
    },
    inputStyle: [Object, String],
    inputClass: [Object, String],
    autocomplete: String,
  },
  computed: {
    bottomSlots() {
      return !!this.hint || !!this.$slots.hint;
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>
